let managementExportData = {
  //   version: 1.133,
  //   invoiceType: [],
  //   splitBillFlag: [],
  //   通用机打发票
  115: [
    {
      label: '发票代码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceCode',
    },
    {
      label: '发票号码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '日期',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceDate',
    },
    {
      label: '金额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalAmt',
    },
    {
      label: '行业分类',
      selected: true,
      defaultWord: true,
      fieldName: 'industryCategory',
    },
    {
      label: '品名',
      selected: true,
      defaultWord: true,
      fieldName: 'productName',
    },
    {
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //27
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //9
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  // 航空运输电子客票行程单
  109: [
    {
      label: '印刷序号',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '姓名',
      selected: true,
      defaultWord: true,
      fieldName: 'userName',
    },
    {
      label: '身份证件号码',
      selected: true,
      defaultWord: true,
      fieldName: 'idNumber',
    },
    {
      label: '行程日期',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceDate',
    },
    {
      label: '出发地',
      selected: true,
      defaultWord: true,
      fieldName: 'departure',
    },
    {
      label: '目的地',
      selected: true,
      defaultWord: true,
      fieldName: 'destination',
    },
    {
      //5
      label: '票价',
      selected: true,
      defaultWord: true,
      fieldName: 'ticketPrice',
    },
    {
      //6
      label: '民航发展基金',
      selected: true,
      defaultWord: true,
      fieldName: 'constructionFee',
    },
    {
      label: '燃油附加费',
      selected: true,
      defaultWord: true,
      fieldName: 'fuelSurcharge',
    },
    {
      //8
      label: '其他税费',
      selected: true,
      defaultWord: true,
      fieldName: 'otherTaxes',
    },
    {
      label: '合计金额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalSum',
    },
    {
      //10
      label: '税率',
      selected: true,
      defaultWord: true,
      fieldName: 'taxRate',
    },
    {
      label: '税额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalTaxamt',
    },
    {
      label: '电子客票号码',
      selected: true,
      defaultWord: true,
      fieldName: 'eTicket',
    },
    {
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '抵扣标志',
      selected: true,
      defaultWord: true,
      fieldName: 'deductionFlag',
    },
    {
      //15
      label: '抵扣属期',
      selected: true,
      defaultWord: true,
      fieldName: 'dkssq',
    },
    {
      label: '转出属期',
      selected: true,
      defaultWord: true,
      fieldName: 'zcssq',
    },
    {
      label: '转出类型',
      selected: true,
      defaultWord: true,
      fieldName: 'turnOutType',
    },
    {
      label: '客运标志',
      selected: true,
      defaultWord: true,
      fieldName: 'passengerFlag',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //27
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //9
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  // 铁路车票 & 公路、水路发票
  '110,111': [
    {
      label: '发票号码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '姓名',
      selected: true,
      defaultWord: true,
      fieldName: 'userName',
    },
    {
      //3
      label: '身份证件号码',
      selected: true,
      defaultWord: true,
      fieldName: 'idNumber',
    },
    {
      label: '日期',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceDate',
    },
    {
      label: '出发地',
      selected: true,
      defaultWord: true,
      fieldName: 'departure',
    },
    {
      label: '目的地',
      selected: true,
      defaultWord: true,
      fieldName: 'destination',
    },
    {
      label: '金额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalAmt',
    },
    {
      label: '税率',
      selected: true,
      defaultWord: true,
      fieldName: 'taxRate',
    },
    {
      label: '税额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalTaxamt',
    },
    {
      //9
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '抵扣标志',
      selected: true,
      defaultWord: true,
      fieldName: 'deductionFlag',
    },
    {
      label: '抵扣属期',
      selected: true,
      defaultWord: true,
      fieldName: 'dkssq',
    },
    {
      label: '转出属期',
      selected: true,
      defaultWord: true,
      fieldName: 'zcssq',
    },
    {
      label: '转出类型',
      selected: true,
      defaultWord: true,
      fieldName: 'turnOutType',
    },
    {
      //14
      label: '客运标志',
      selected: true,
      defaultWord: true,
      fieldName: 'passengerFlag',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //18
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //19
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      //30
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      //31
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      //34
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '座席',
      selected: true,
      defaultWord: true,
      fieldName: 'seatType',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  // 出租车发票 6
  112: [
    {
      label: '发票代码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceCode',
    },
    {
      label: '发票号码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '日期',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceDate',
    },
    {
      label: '金额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalAmt',
    },
    {
      label: '出发地',
      selected: true,
      defaultWord: true,
      fieldName: 'departure',
    },
    {
      label: '目的地',
      selected: true,
      defaultWord: true,
      fieldName: 'destination',
    },
    {
      label: '上车时间',
      selected: true,
      defaultWord: true,
      fieldName: 'getTime',
    },
    {
      label: '下车时间',
      selected: true,
      defaultWord: true,
      fieldName: 'offTime',
    },
    {
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //27
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //9
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '车号',
      selected: true,
      defaultWord: true,
      fieldName: 'plateNum',
    },
    {
      label: '里程',
      selected: true,
      defaultWord: true,
      fieldName: 'mileage',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  // 过桥、路费发票 7
  114: [
    {
      label: '发票代码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceCode',
    },
    {
      label: '发票号码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '开票日期',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceDate',
    },
    {
      label: '金额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalAmt',
    },
    {
      label: '入口',
      selected: true,
      defaultWord: true,
      fieldName: 'entrance',
    },
    {
      label: '出口',
      selected: true,
      defaultWord: true,
      fieldName: 'exit',
    },
    {
      label: '车型',
      selected: true,
      defaultWord: true,
      fieldName: 'vehicleType',
    },
    {
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //27
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //9
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  // 通用定额发票 8
  108: [
    {
      label: '发票代码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceCode',
    },
    {
      label: '发票号码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '金额',
      selected: true,
      defaultWord: true,
      fieldName: 'oneAmount',
    },
    {
      label: '份数',
      selected: true,
      defaultWord: true,
      fieldName: 'number',
    },
    {
      label: '总额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalSum',
    },
    {
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //27
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //9
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  // 停车费发票 9
  113: [
    {
      label: '发票号码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '日期',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceDate',
    },
    {
      label: '金额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalAmt',
    },
    {
      label: '开始时间',
      selected: true,
      defaultWord: true,
      fieldName: 'getTime',
    },
    {
      label: '结束时间',
      selected: true,
      defaultWord: true,
      fieldName: 'offTime',
    },
    {
      label: '车牌号',
      selected: true,
      defaultWord: true,
      fieldName: 'plateNumber',
    },
    {
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //27
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //9
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  // 机动车、二手车销售统一发票 10 11
  '119,118': [
    {
      //1
      label: '发票代码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceCode',
    },
    {
      label: '发票号码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '开票日期',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceDate',
    },
    {
      label: '销方单位名称',
      selected: true,
      defaultWord: true,
      fieldName: 'saleName',
    },
    {
      //5
      label: '销方税号',
      selected: true,
      defaultWord: true,
      fieldName: 'saleCreditCode',
    },
    {
      //6
      label: '销方地址',
      selected: true,
      defaultWord: true,
      fieldName: 'saleAddress',
    },
    {
      //7
      label: '销方电话',
      selected: true,
      defaultWord: true,
      fieldName: 'salePhone',
    },
    {
      //8
      label: '销方开户银行',
      selected: true,
      defaultWord: true,
      fieldName: 'saleBank',
    },
    {
      //9
      label: '销方账号',
      selected: true,
      defaultWord: true,
      fieldName: 'saleBankAccount',
    },
    {
      //10
      label: '金额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalAmt',
    },
    {
      label: '税率',
      selected: true,
      defaultWord: true,
      fieldName: 'taxRate',
    },
    {
      label: '税额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalTaxamt',
    },
    {
      label: '价税合计',
      selected: true,
      defaultWord: true,
      fieldName: 'adValoremTotal',
    },
    {
      label: '购方名称',
      selected: true,
      defaultWord: true,
      fieldName: 'custName',
    },
    {
      //15
      label: '购方税号',
      selected: true,
      defaultWord: true,
      fieldName: 'custCreditCode',
    },
    {
      label: '完税凭证号码', //10机动车为'完税凭证号码'、11二手车为'备注'
      selected: true,
      defaultWord: true,
      fieldName: 'proofNumber',
    },
    {
      label: '发票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceStatus',
    },
    {
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '抵扣标志',
      selected: true,
      defaultWord: true,
      fieldName: 'deductionFlag',
    },
    {
      //20
      label: '抵扣属期',
      selected: true,
      defaultWord: true,
      fieldName: 'dkssq',
    },
    {
      label: '转出属期',
      selected: true,
      defaultWord: true,
      fieldName: 'zcssq',
    },
    {
      label: '转出类型',
      selected: true,
      defaultWord: true,
      fieldName: 'turnOutType',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //27
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //9
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  // 医疗费用收据、教育费用收据 12 13
  '116,117': [
    {
      label: '收据号码',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceNumber',
    },
    {
      label: '日期',
      selected: true,
      defaultWord: true,
      fieldName: 'invoiceDate',
    },
    {
      label: '姓名',
      selected: true,
      defaultWord: true,
      fieldName: 'userName',
    },
    {
      label: '金额',
      selected: true,
      defaultWord: true,
      fieldName: 'totalAmt',
    },
    {
      label: '收票状态',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionStatus',
    },
    {
      label: '报销单号',
      selected: true,
      defaultWord: true,
      fieldName: 'claimNumber',
    },
    {
      label: '项目名称',
      selected: true,
      defaultWord: true,
      fieldName: 'projectName',
    },
    {
      label: '项目编号',
      selected: true,
      defaultWord: true,
      fieldName: 'projectCode',
    },
    {
      //27
      label: '录入方式',
      selected: true,
      defaultWord: true,
      fieldName: 'billSource',
    },
    {
      //9
      label: '人员/录入时间',
      selected: true,
      defaultWord: true,
      fieldName: 'realName',
    },
    {
      label: '收票人/时间',
      selected: true,
      defaultWord: true,
      fieldName: 'collectionPerson',
    },
    {
      label: '入账分类',
      selected: true,
      defaultWord: true,
      fieldName: 'rzflId',
    },
    {
      label: '进项转出标志',
      selected: true,
      defaultWord: true,
      fieldName: 'transferOutSign',
    },
    {
      label: '进项转出金额',
      selected: true,
      defaultWord: true,
      fieldName: 'transferAmount',
    },
    {
      label: '报销状态',
      selected: true,
      defaultWord: true,
      fieldName: 'reimbursementStatus',
    },
    {
      label: '结算单号',
      selected: true,
      defaultWord: true,
      fieldName: 'statementNumber',
    },
    {
      label: '凭证号',
      selected: true,
      defaultWord: true,
      fieldName: 'voucherNumber',
    },
    {
      label: '来源系统',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceSystem',
    },
    {
      label: '管理分区',
      selected: true,
      defaultWord: true,
      fieldName: 'managementPartition',
    },
    {
      label: '流程申请人',
      selected: true,
      defaultWord: true,
      fieldName: 'processApplicant',
    },
    {
      label: '机构名称',
      selected: true,
      defaultWord: true,
      fieldName: 'orgId',
    },
    {
      label: '事业部',
      selected: true,
      defaultWord: true,
      fieldName: 'departmentNo',
    },
    {
      label: '所属大区',
      selected: true,
      defaultWord: true,
      fieldName: 'regionName',
    },
    {
      label: '管理城市',
      selected: true,
      defaultWord: true,
      fieldName: 'cityName',
    },
    {
      label: '主管税局所在省市',
      selected: true,
      defaultWord: true,
      fieldName: 'province',
    },
    {
      label: '入账月份',
      selected: true,
      defaultWord: true,
      fieldName: 'paymentMonth',
    },
    {
      label: '账套编码',
      selected: true,
      defaultWord: true,
      fieldName: 'accountSetCode',
    },
    {
      label: '来源系统编码',
      selected: true,
      defaultWord: true,
      fieldName: 'sourceAppId',
    },
  ],
  //   profileType: '105',
}

export default managementExportData



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/management/exportConfigData.js